/* ---- danchel 3D helpers ---- */
(function(){
  var T = window.THREE;
  if(!T){ window.DAN = null; return; }

  function labelTexture(){
    var c = document.createElement('canvas'); c.width = 1400; c.height = 1024;
    var x = c.getContext('2d');
    var g = x.createLinearGradient(0, 1024, 0, 0);
    g.addColorStop(0, '#E9569C'); g.addColorStop(.45, '#F07FB6'); g.addColorStop(1, '#F6A9CE');
    x.fillStyle = g; x.fillRect(0, 0, 1400, 1024);
    x.save(); x.translate(700, 512); x.rotate(-Math.PI/2);
    x.fillStyle = '#fff'; x.textAlign = 'left'; x.textBaseline = 'middle';
    x.font = '500 78px Jost, Helvetica, sans-serif'; x.fillText('danchel', -420, -108);
    x.fillRect(-186, -140, 17, 17);
    x.font = '400 34px Jost, Helvetica, sans-serif';
    x.fillText('PDRN PINK COLLAGEN', -420, -18);
    x.fillText('VOLUME MULTI BALM', -420, 26);
    x.font = '400 26px Jost, Helvetica, sans-serif'; x.fillText('10 g / 0.35 oz', -420, 78);
    x.restore();
    x.textAlign = 'center'; x.fillStyle = '#fff';
    x.font = '300 92px Jost, Helvetica, sans-serif'; x.fillText('5', 980, 470);
    x.font = '300 44px Jost, Helvetica, sans-serif'; x.fillText('%', 1032, 430);
    x.fillRect(915, 512, 130, 9);
    var t = new T.CanvasTexture(c); t.anisotropy = 8; return t;
  }

  /* returns { group, sleeve, core, cap, mats } — cap is NOT added to group */
  function stick(){
    var group = new T.Group();
    var mats = [
      new T.MeshPhysicalMaterial({map:labelTexture(), roughness:.34, clearcoat:.75, clearcoatRoughness:.28}),
      new T.MeshPhysicalMaterial({color:0xF07FB6, roughness:.4, clearcoat:.5}),
      new T.MeshPhysicalMaterial({color:0xE9569C, roughness:.45})
    ];
    var sleeve = new T.Group();
    var body = new T.Mesh(new T.CylinderGeometry(.62, .62, 2.5, 96, 1), mats);
    body.position.y = -.55; sleeve.add(body);
    var collar = new T.Mesh(new T.CylinderGeometry(.585, .6, .34, 96),
      new T.MeshPhysicalMaterial({color:0xF9C2DC, roughness:.32, clearcoat:.7}));
    collar.position.y = .85; sleeve.add(collar);

    var balm = new T.MeshPhysicalMaterial({color:0xFDF0F5, roughness:.16, clearcoat:1, clearcoatRoughness:.1});
    var core = new T.Group();
    var nub = new T.Mesh(new T.CylinderGeometry(.55, .565, .5, 96), balm);
    nub.position.y = 1.27; core.add(nub);
    var dome = new T.Mesh(new T.SphereGeometry(.55, 64, 32, 0, Math.PI*2, 0, Math.PI/2), balm);
    dome.position.y = 1.52; dome.scale.y = .62; core.add(dome);

    var capMat = new T.MeshPhysicalMaterial({color:0xF7B4D6, roughness:.36, clearcoat:.65, clearcoatRoughness:.3});
    var cap = new T.Group();
    var wall = new T.Mesh(new T.CylinderGeometry(.655, .655, 1.3, 96, 1, true), capMat);
    wall.position.y = 1.3; cap.add(wall);
    var top = new T.Mesh(new T.SphereGeometry(.655, 64, 32, 0, Math.PI*2, 0, Math.PI/2), capMat);
    top.position.y = 1.95; top.scale.y = .38; cap.add(top);

    group.add(sleeve); group.add(core);
    return {group:group, sleeve:sleeve, core:core, cap:cap, mats:mats};
  }

  function scene(canvas, o){
    o = o || {};
    var sc = new T.Scene();
    var cam = new T.PerspectiveCamera(o.fov || 32, 1, .1, 100);
    cam.position.set(0, o.camY || .2, o.camZ || 9);
    var rnd = new T.WebGLRenderer({canvas:canvas, alpha:true, antialias:true});
    rnd.setPixelRatio(Math.min(devicePixelRatio, 2));
    rnd.outputEncoding = T.sRGBEncoding;
    sc.add(new T.HemisphereLight(0xffffff, 0xf6dde8, .85));
    var a = new T.DirectionalLight(0xffffff, .95); a.position.set(4, 6, 6); sc.add(a);
    var b = new T.DirectionalLight(0xffdfec, .5); b.position.set(-6, 2, 3); sc.add(b);
    var c = new T.DirectionalLight(0xffffff, .7); c.position.set(-2, 3, -6); sc.add(c);
    var live = false;
    new IntersectionObserver(function(e){ live = e[0].isIntersecting; }, {threshold:.01}).observe(canvas);
    function resize(){
      var r = canvas.getBoundingClientRect();
      if(!r.width || !r.height) return;
      rnd.setSize(r.width, r.height, false);
      cam.aspect = r.width / r.height; cam.updateProjectionMatrix();
    }
    addEventListener('resize', resize);
    setTimeout(resize, 60); resize();
    return {scene:sc, cam:cam, rnd:rnd, resize:resize,
      live:function(){ return live; },
      draw:function(){ rnd.render(sc, cam); }};
  }

  function shadow(y, size){
    var c = document.createElement('canvas'); c.width = c.height = 256;
    var x = c.getContext('2d');
    var g = x.createRadialGradient(128, 128, 6, 128, 128, 124);
    g.addColorStop(0, 'rgba(180,110,145,.4)'); g.addColorStop(1, 'rgba(180,110,145,0)');
    x.fillStyle = g; x.fillRect(0, 0, 256, 256);
    var m = new T.Mesh(new T.PlaneGeometry(size || 3.6, size || 3.6),
      new T.MeshBasicMaterial({map:new T.CanvasTexture(c), transparent:true, depthWrite:false}));
    m.rotation.x = -Math.PI/2; m.position.y = y; m.scale.y = .6;
    return m;
  }

  /* pointer drag → spin. returns update(dt) */
  function spin(canvas, group, base){
    var vel = base, down = false, lastX = 0;
    canvas.addEventListener('pointerdown', function(e){
      down = true; lastX = e.clientX;
      try{ canvas.setPointerCapture(e.pointerId); }catch(err){}
    });
    canvas.addEventListener('pointermove', function(e){
      if(!down) return;
      vel = (e.clientX - lastX) * .006; group.rotation.y += vel; lastX = e.clientX;
    });
    canvas.addEventListener('pointerup', function(){ down = false; });
    canvas.addEventListener('pointercancel', function(){ down = false; });
    return function(dt){
      if(down) return;
      vel += (base - vel) * .04;
      group.rotation.y += vel * dt;
    };
  }

  window.DAN = {labelTexture:labelTexture, stick:stick, scene:scene, shadow:shadow, spin:spin};
})();
